import DeleteDigitalAssetRequestModelBase from '../_generated/modelBases/delete-digital-asset-request-model-base';

export default class DeleteDigitalAssetRequestModel extends DeleteDigitalAssetRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
